import React from 'react'
import { CLI, FEATURES, FRONT, PROGRAM_CINEMAS, PROGRAM_ELBENWALDARTICLES_ITEMS, THEME, TRANSLATION } from '../constants/state'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import MovieInformation from './MovieInformation'
import EntryPagesChildClass from '../General/EntryPagesChildClass'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    translation: getData(state, TRANSLATION),
    theme: getData(state, THEME),
    elbenwaldItems: getData(state, PROGRAM_ELBENWALDARTICLES_ITEMS),
    features: getData(state, FEATURES),
    cliData: getData(state, CLI),
    cinemas: getData(state, PROGRAM_CINEMAS)
})

const MovieInformationContainer = ({
    itemID, 
    theme, 
    moviesData, 
    translation, 
    queryStringValues,
    filterType, 
    filterValue,
    backgroundImage, 
    activePerformance,
    scrollToPosition, 
    isMobile, 
    onCloseDetails,
    trailerImage,
    cinemaDataFront,
    toggleMovieDatesOnMobileView,
    currentDateActive,
    dayFilters,
    itemLink,
    detailsOpen,
    onOpenDetails,
    overviewFilterIgnoreOnPerformances,
    closeOffset,
    onCloseInformation,
    hideCinemaSelector,
    elbenwaldItems,
    features,
    onOpenIframe,
    cliData,
    cinemas
}) => {

    const {
        attribute_styling,
        information_style
    } = cinemaDataFront

    const {theme_colors} = theme

    const elbenwald = EntryPagesChildClass.getElbenwald(features, elbenwaldItems, cliData, cinemas)

    return (
        <MovieInformation
            itemID={itemID}
            translation={translation}
            activePerformance={activePerformance} 
            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView} 
            attributeStyling={attribute_styling}
            isMobile={isMobile}
            currentDateActive={currentDateActive}
            dayFilters={dayFilters} 
            moviesData={moviesData} 
            elbenwald={elbenwald}
            filterType={filterType}
            filterValue={filterValue}
            queryStringValues={queryStringValues}
            theme={theme_colors}
            itemLink={itemLink}
            detailsOpen={detailsOpen}
            backgroundImage={backgroundImage}
            trailerImage={trailerImage}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            scrollToPosition={scrollToPosition} 
            closeOffset={closeOffset}
            informationStyling={information_style}
            onOpenDetails={onOpenDetails} 
            onCloseDetails={onCloseDetails} 
            onCloseInformation={onCloseInformation} 
            hideCinemaSelector={hideCinemaSelector}
            onOpenIframe={onOpenIframe} 
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieInformationContainer)